import React from 'react';

function Footer() {
    return (
        <div className="tc i c pt4 pb2">
            Harshit Chopra © 2020 | All Rights Reserved
        </div>
    );
}
export default Footer;